import SayfalarService from "../../../services/SayfalarService";
import _ from "lodash";

export default {
  namespaced: true,
  state: () => ({
    sayfaListesi: [],
  }),
  getters: {
    sayfalarGrouped: (state) => (sayfaListesi = null) => {
      // return _.sortBy(cat, 'parent')

      var parseCatsTree = function(cats, parent = [], depth = 0) {
        /**
         * Boş dizi oluştur
         */
        var categories = [];

        if (parent.length === 0) {
          /**
           * En üst kategoriyi al
           */
          parent = _.find(cats, { parent: 0 });
        }

        /**
         * Kategori derinliğini ayarla
         */
        parent.depth = depth;

        /**
         * Üst kategoriyi kaldır
         */
        var catList = _.remove(cats, (o) => {
          return o.parent !== 0;
        });
        /**
         * Sayfalar dizisi içerisine ekle
         */
        categories.push(parent);

        /**
         * Listeden alt sayfaları getir
         */
        var cat = _.filter(catList, {
          parent: parent.code,
        });

        /**
         * Her seferinde derinliği +1 artır
         */
        depth++;

        /**
         * Alt kategorileri tekrar tekrar oluştur
         */
        if (cat.length > 0) {
          cat.forEach((d) => {
            categories = categories.concat(
              parseCatsTree(JSON.parse(JSON.stringify(catList)), d, depth)
            );
          });
        }

        return categories;
      };

      var grouped = _.mapValues(
        _.groupBy(sayfaListesi ?? state.sayfaListesi, "hierarchy")
      );

      var catList = [];
      Object.keys(grouped).forEach((groupKey) => {
        catList.push(
          parseCatsTree(JSON.parse(JSON.stringify(grouped[groupKey])))
        );
      });
      return _.sortBy(catList, ['code']);
    },
  },
  mutations: {
    setSayfaListesi: (state, data) => {
      state.sayfaListesi = data;
    },
  },
  actions: {
    sayfaListesi: ({ commit }) => {
      return new Promise((resolve, reject) => {
        SayfalarService.sayfaListesi()
          .then((res) => {
            commit("setSayfaListesi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
